<template>
	<div class="common-loading-state text-center">
		<div class="common-loading-state__title mb-1 font-weight-semibold text-body-1 text-high-emphasis">
			{{ loadingText }}
		</div>
		<div class="common-loading-state__description mx-auto text-medium-emphasis">
			{{ description }}
		</div>
	</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/userStore';
import { camelCase, isEmpty } from 'lodash-es';
import { ROLES, type Role } from '@teamworksdev/influencer-core';

const props = defineProps<{
	dataType?: string;
}>();

const { rt, t, tm } = useI18n();
const userStore = useUserStore();

const loadingText = computed(() => {
	let text = t('loading');
	if (props.dataType) text += ` ${props.dataType}`;
	return `${text}...`;
});

const currentRole = computed<string | undefined>(() => {
	return Object.keys(ROLES).find((role) => (ROLES as Record<string, Role>)[role] === userStore.profile?.role_id);
});

const description = computed(() => {
	if (!currentRole.value) return t('commonLoadingState.descriptions.default');
	const descriptions: Record<number, any> = tm(`commonLoadingState.descriptions.${camelCase(currentRole.value)}`);
	return !isEmpty(descriptions) ? rt(descriptions[Math.floor(Math.random() * Object.keys(descriptions).length)]) : t('commonLoadingState.descriptions.default');
});
</script>

<style lang="scss" scoped>
.common-loading-state {
	&__description {
		max-width: 700px;
		width: 100%;
	}
}
</style>
